import React, { useEffect, useState, useRef } from 'react';
import { getBaseDir, apiCall } from '../../utils';
import BankReconciliationBodyRow from './BankReconciliationBodyRow';
import Swal from 'sweetalert2';
import moment from 'moment-timezone';

const BankReconciliationBody = ({
  isLoading = false,
  headData,
  updateHeadData,
  updateBodyData,
  bodyData,
  removeBodyData,
  branches
}) => {

  const [currentTab, setCurrentTab] = useState('all');

  const installmentsSearchModalData = useRef({
    idx: null,
    currentValue: 0,
    searchValue: null,
    selectedDate: null,
    selectedBranch: null,
    branchList: {},
    fetchedData: [],
    filteredData: false,
    debounceSearchInstallments: null,
    formData: null
  });
  const openedInstallmentSearchModal = useRef(false);

  const renderTabContent = () => {
    return (
      <>
        {bodyData.filter(item => currentTab === 'all' ? true : (currentTab === 'receivables' ? item.TIPO == 0 : item.TIPO == 1)).map((item, index) => (
          <BankReconciliationBodyRow
            key={`${item.ID_TRANSACAO}-${item.ID}`}
            idx={index}
            bodyData={item}
            installmentsSearchModalData={installmentsSearchModalData}
            openedInstallmentSearchModal={openedInstallmentSearchModal}
            renderInstallmentsSearchModalData={renderInstallmentsSearchModalData}
            updateBodyData={updateBodyData}
            removeBodyData={removeBodyData}
            branches={branches}
            handleConciliate={handleConciliate}
          />
        ))}
      </>
    )
  }

  const hasInitializedInstallmentsSearchModal = useRef(false);

  const startInstallmentsSearchModal = () => {
    if (hasInitializedInstallmentsSearchModal.current) return;
    hasInitializedInstallmentsSearchModal.current = true;

    // Função para calcular totais
    const calculateTotals = () => {
      let totalSelected = 0;
      $('.installment-checkbox:checked').each(function () {
        totalSelected += parseFloat($(this).data('valor'));
      });

      const difference = Math.abs(installmentsSearchModalData.current.currentValue - totalSelected);

      $('#selected-total').text(`R$ ${totalSelected.toFixed(2)}`);

      const $differenceElement = $('#difference-value');
      $differenceElement.text(`R$ ${difference.toFixed(2)}`);

      //console.log('difference arredondada', difference.toFixed(2));
      //console.log('difference', difference);
      const arredondada = difference.toFixed(2);

      // Adicionar classes de cor baseado na diferença
      if (arredondada == 0) {
        $('#bank-reconciliation-confirm-installments').prop('disabled', false);
        $differenceElement.removeClass('text-danger text-warning').addClass('text-success');
      } else if (arredondada < installmentsSearchModalData.current.currentValue) {
        if (installmentsSearchModalData.current.formData.VALUE < 0) {
          $('#bank-reconciliation-confirm-installments').prop('disabled', true);
        }
        $differenceElement.removeClass('text-success text-warning').addClass('text-danger');
      } else if (arredondada > installmentsSearchModalData.current.currentValue) {
        if (installmentsSearchModalData.current.formData.VALUE < 0) {
          $('#bank-reconciliation-confirm-installments').prop('disabled', true);
        }
        $differenceElement.removeClass('text-success text-danger').addClass('text-warning');
      } else {
        $differenceElement.removeClass('text-success text-danger text-warning');
      }
    }

    // Manipular seleção de todas as parcelas
    $(document).on('change', '#select-all-installments', function () {
      $('.installment-checkbox').prop('checked', $(this).prop('checked'));
      calculateTotals();
    });

    // Manipular seleção individual
    $(document).on('change', '.installment-checkbox', function () {
      calculateTotals();
    });

    // Confirmar seleção de parcelas
    $(document).on('click', '#bank-reconciliation-confirm-installments', function () {
      const selectedInstallments = [];
      $('.installment-checkbox:checked').each(function () {
        selectedInstallments.push({
          id: $(this).data('id'),
          tipo: $(this).data('tipo')
        });
      });

      if (selectedInstallments.length > 0) {
        //installmentsSearchModalData.current.formData.PARCELAS = selectedInstallments;
        handleConciliate(null, selectedInstallments);
      } else {
        Swal.fire({
          title: 'Atenção',
          text: 'Selecione pelo menos um lançamento.',
          icon: 'warning'
        });
      }
    });

    // Confirmar seleçã ode parcelas de pagamento parcial
    $(document).on('click', '#bank-reconciliation-confirm-installments', function () {
      const selectedInstallments = [];
      $('.installment-checkbox:checked').each(function () {
        selectedInstallments.push({
          id: $(this).data('id'),
          tipo: $(this).data('tipo')
        });
      });

      if (selectedInstallments.length > 0) {
        handleConciliate(null, selectedInstallments, null, false);
      } else {
        Swal.fire({
          title: 'Atenção',
          text: 'Selecione pelo menos um lançamento.',
          icon: 'warning'
        });
      }
    });

    $(document).on('click', '#bank-reconciliation-confirm-partial-payment-installments', function () {
      const selectedInstallments = [];
      $('.installment-checkbox:checked').each(function () {
        selectedInstallments.push($(this).data('id'));
      });

      if (selectedInstallments.length > 0) {
        //handle();
        //console.log('installmentsSearchModalData.current.formData', installmentsSearchModalData.current.formData);
        //installmentsSearchModalData.current.formData.PARCELAS = selectedInstallments;
        handleConciliate(null, selectedInstallments, null, true);
      } else {
        Swal.fire({
          title: 'Atenção',
          text: 'Selecione pelo menos um lançamento.',
          icon: 'warning'
        });
      }
    });

    // Função centralizada para aplicar todos os filtros
    const applyFilters = () => {
      const { searchValue, selectedDate, selectedBranch, fetchedData } = installmentsSearchModalData.current;

      let filtered = fetchedData;
      let hasFilter = false;

      // Filtro por Filial
      if (selectedBranch && selectedBranch !== '') {
        hasFilter = true;
        filtered = filtered.filter(item => item.FILIAL_ID == selectedBranch);
      }

      // Filtro por Data
      if (selectedDate && selectedDate !== '') {
        hasFilter = true;
        filtered = filtered.filter(item => {
          const venc = moment(item.DATA_VENCIMENTO)?.format('YYYY-MM-DD');
          const pag = moment(item.DATA_PAGAMENTO)?.format('YYYY-MM-DD');
          return venc == selectedDate || pag == selectedDate;
        });
      }

      // Filtro por Texto (Nome do Cliente)
      if (searchValue && searchValue !== '') {
        hasFilter = true;

        const normalizeText = (text) => {
          return text ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";
        };

        const normalizedSearch = normalizeText(searchValue);

        filtered = filtered.filter(item => {
          return item.CLIENTE_NOME && normalizeText(item.CLIENTE_NOME).includes(normalizedSearch);
        });
      }

      installmentsSearchModalData.current.filteredData = hasFilter ? filtered : false;
      renderInstallmentsSearchModalData();
    };

    // Helper unificado para capturar mudanças e agendar o filtro (debounce)
    const handleSearchUpdate = () => {
      const searchValue = $('#search-installments').val() || null;
      const selectedDate = $('#search-installments-by-date').val() || null;
      // Captura o valor do select de filiais
      const searchBranch = $('#search-installments-branches').val() || null;

      if (installmentsSearchModalData.current.debounceSearchInstallments) {
        clearTimeout(installmentsSearchModalData.current.debounceSearchInstallments);
      }

      installmentsSearchModalData.current.searchValue = searchValue;
      installmentsSearchModalData.current.selectedDate = selectedDate;
      installmentsSearchModalData.current.selectedBranch = searchBranch;

      installmentsSearchModalData.current.debounceSearchInstallments = setTimeout(() => {
        applyFilters();
      }, 1350);
    };

    // Manipular busca por data
    $(document).on('change', '#search-installments-by-date', handleSearchUpdate);

    // Manipular busca por descrição
    $(document).on('keyup', '#search-installments', handleSearchUpdate);

    // Manipular busca por filial
    $(document).on('change', '#search-installments-branches', handleSearchUpdate);

    // Manipular duplicação de parcela
    $(document).on('click', '.js-conciliation-duplicate-installment', function () {
      const installmentId = $(this).data('id');
      const tipo = $(this).data('tipo');
      //console.log('installmentId', installmentId);
      let selfBtn = $(this);
      selfBtn.prop('disabled', true);
      Swal.fire({
        title: 'Duplicar parcela',
        text: 'Tem certeza que deseja duplicar esta parcela?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        //console.log('result', result);
        if (result.isConfirmed) {
          apiCall({
            method: 'POST',
            endpoint: 'api/v1/financial/bills-to-pay/duplicate',
            data: { installmentId: installmentId, type: tipo },
            successCallback: function (response) {
              selfBtn.prop('disabled', false);
              //console.log('success', response);
              Swal.fire({
                title: 'Conta a pagar duplicada',
                text: 'A conta a pagar foi duplicada com sucesso',
                icon: 'success'
              });
              fetchInstallmentSearchModalData();
            },
            errorCallback: function (response) {
              console.log('error', response);
              selfBtn.prop('disabled', false);
            }
          });
        }
      });
    });

    // Manipular exclusão de parcela
    $(document).on('click', '.js-conciliation-delete-installment', function () {
      const installmentId = $(this).data('id');
      const tipo = $(this).data('tipo');
      //console.log('installmentId', installmentId);
      let selfBtn = $(this);
      selfBtn.prop('disabled', true);
      Swal.fire({
        title: 'Excluir parcela',
        text: 'Tem certeza que deseja excluir esta parcela?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        //console.log('result', result);
        if (result.isConfirmed) {
          apiCall({
            method: 'DELETE',
            endpoint: 'api/v1/financial/bills-to-pay/delete?billId=' + installmentId + '&deleteAllInFuture=0',
            successCallback: function (response) {
              selfBtn.prop('disabled', false);
              Swal.fire({
                title: 'Conta a pagar excluída',
                text: 'A conta a pagar foi excluída com sucesso',
                icon: 'success'
              });
              fetchInstallmentSearchModalData();
            },
            errorCallback: function (response) {
              console.log('error', response);
              selfBtn.prop('disabled', false);
            }
          });
        }
      });
    });


    $(`#modal-bank-reconciliation-search-financial-installments`).on('hidden.bs.modal', function () {
      if (openedInstallmentSearchModal.current) {
        openedInstallmentSearchModal.current = false;
      }
    });
  }

  const testout = () => {
    //console.log('installmentsSearchModalData.current.formData', installmentsSearchModalData.current.formData);
  }

  const renderHeaderInfo = (currentValue) => `
    <div class="alert alert-info mb-3 sticky-top" style="top: 0; z-index: 1020; background-color: rgba(255, 255, 255, 0.95); border-radius: 0;">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <p class="mb-0">Valor da movimentação: R$ ${currentValue.toFixed(2)}</p>
          <p class="mb-0">Valor selecionado: <span id="selected-total">R$ 0,00</span></p>
        </div>
        <div>
          <p class="mb-0">Diferença: <span id="difference-value" class="fw-bold">R$ ${currentValue.toFixed(2)}</span></p>
        </div>
      </div>
    </div>
  `;

  const renderSearchArea = (searchValue, selectedDate, selectedBranch, branchList) => {
    // Gerar uma chave única baseada nos parâmetros
    const searchAreaKey = `${searchValue || ''}-${selectedDate || ''}-${selectedBranch || ''}-${Object.keys(branchList).length}`;

    // Verificar se já existe um elemento com a mesma chave no DOM
    const existingElement = document.querySelector(`[data-search-area-key="${searchAreaKey}"]`);
    if (existingElement) {
      // Se o elemento já existe e os valores são os mesmos, retornar o HTML existente
      const currentSearchValue = existingElement.querySelector('#search-installments')?.value || '';
      const currentDateValue = existingElement.querySelector('#search-installments-by-date')?.value || '';
      const currentBranchValue = existingElement.querySelector('#search-installments-branches')?.value || '';

      if (currentSearchValue === (searchValue || '') &&
        currentDateValue === (selectedDate || '') &&
        currentBranchValue === (selectedBranch || '')) {
        return existingElement.outerHTML;
      }
    }

    //console.log('branchList', branchList) 
    let branchesHtml = Object.keys(branchList).length > 1 ? '<option value="" selected>Todas unidades</option>' : '';
    Object.keys(branchList).map((v, i) => {
      let id = v;
      let filialName = branchList[v];
      //console.log('filial id/name', id, filialName);
      branchesHtml += `<option value="${id}" ${selectedBranch == id ? 'selected' : ''}>${filialName}</option>`;
    })

    const html = `
      <div class="mb-3 sticky-top" style="top: 80px; z-index: 1019; background-color: white; padding: 10px 0;" data-search-area-key="${searchAreaKey}">
        <div class="row">
          <div class="col-sm-12 col-md-4 col-lg-4">
            <div class="form-group">
              <label for="search-installments">Buscar lançamentos</label>
              <input type="text" class="form-control" id="search-installments" placeholder="Buscar lançamentos" value="${searchValue ?? ''}">
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <div class="form-group">
              <label for="search-installments-by-date">Buscar lançamentos por data</label>
              <input type="date" class="form-control" id="search-installments-by-date" placeholder="Buscar lançamentos por data" value="${selectedDate ?? ''}">
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <div class="form-group">
             <label for="search-installments-by-date">Filial dos lançamentos</label>
              <select class="form-control" id="search-installments-branches">
                ${branchesHtml}
              </select>
            </div>
          </div>
        </div>
      </div>
    `;

    return html;
  }

  const renderTableRow = (item) => {
    if (!item.CLIENTE_NOME) return '';

    try {
      if (!installmentsSearchModalData.current.branchList?.[item.FILIAL_ID]) {
        installmentsSearchModalData.current.branchList[item.FILIAL_ID] = item.FILIAL;
      }
    } catch (ex) {
      console.error(`error at renderTableRow item:`, item);
      console.error(`error at renderTableRow installmentsSearchModalData.current:`, installmentsSearchModalData.current);
    }

    return `
      <tr>
        <td>
          <input type="checkbox" 
            class="installment-checkbox" 
            data-id="${item.ID}"
            data-valor="${item.VALOR_PARCELA}"
            data-categoria="${item.CATEGORIA_ID}"
            data-centro-custo="${item.CENTRO_DE_CUSTO_ID}"
            ${item.VENDA_ID ? 'data-tipo="venda"' : 'data-tipo="despesa"'}
          />
        </td>
        <td>${item.ID}</td>
        <td>${item.FILIAL}</td>
        <td>${moment(item.DATA_VENCIMENTO).format('DD/MM/YYYY')}</td>
        <td>${moment(item.DATA_PAGAMENTO).format('DD/MM/YYYY')}</td>
        <td>R$ ${parseFloat(item.VALOR_PARCELA).toFixed(2)}</td>
        <td>${item.CLIENTE_NOME || '-'}</td>
        <td>${item.CATEGORIA || '-'}</td>
        <td>${item.CENTRO_DE_CUSTO || '-'}</td>
        <td>${item.OBS || '-'}</td>
        <td>
          ${!item.VENDA_ID ? `
            <div class="btn-group btn-group-sm">
              <button class="btn btn-secondary js-conciliation-duplicate-installment" data-id="${item.ID}" data-tipo="${item.VENDA_ID ? 'venda' : 'despesa'}">
                <i class="fas fa-copy"></i>
              </button>
              <button class="btn btn-danger js-conciliation-delete-installment" data-id="${item.ID}" data-tipo="${item.VENDA_ID ? 'venda' : 'despesa'}">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          ` : '-'}
        </td>
      </tr>
    `;
  };

  // Cache para evitar re-renderizações desnecessárias
  const modalRenderCache = useRef({
    lastData: null,
    lastSearchValue: null,
    lastSelectedDate: null,
    lastSelectedBranch: null,
    lastCurrentValue: null
  });

  const renderInstallmentsSearchModalData = (is_on_load = false) => {
    // Resetar lista de filiais e repopular baseada em TODOS os dados para o filtro funcionar corretamente
    installmentsSearchModalData.current.branchList = {};
    const { currentValue, searchValue, selectedDate, selectedBranch, filteredData, fetchedData } = installmentsSearchModalData.current;

    // Garantir que temos um limite inicial de renderização
    if (typeof installmentsSearchModalData.current.renderLimit === 'undefined') {
      installmentsSearchModalData.current.renderLimit = 50;
    }

    const data = filteredData !== false ? filteredData : fetchedData;
    const modalBody = $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body');

    // Otimização: Evitar JSON.stringify em datasets grandes. Usar assinatura leve.
    const cache = modalRenderCache.current;
    // Assinatura baseada em tamanho e IDs das pontas para detecção rápida de mudanças
    const currentDataSignature = `${data.length}-${data[0]?.ID || 's'}-${data[data.length - 1]?.ID || 'e'}`;

    const dataChanged = currentDataSignature !== cache.lastDataSignature;
    const searchChanged = searchValue !== cache.lastSearchValue;
    const dateChanged = selectedDate !== cache.lastSelectedDate;
    const branchChanged = selectedBranch !== cache.lastSelectedBranch;
    const valueChanged = currentValue !== cache.lastCurrentValue;

    // Se nada mudou, não re-renderizar
    if (!dataChanged && !searchChanged && !dateChanged && !branchChanged && !valueChanged) {
      return;
    }

    // Se os dados ou filtros mudaram, resetar o limite de renderização
    if (dataChanged || searchChanged || dateChanged || branchChanged) {
      installmentsSearchModalData.current.renderLimit = 50;
    }

    // Atualizar cache
    cache.lastDataSignature = currentDataSignature;
    cache.lastSearchValue = searchValue;
    cache.lastSelectedDate = selectedDate;
    cache.lastSelectedBranch = selectedBranch;
    cache.lastCurrentValue = currentValue;

    // Popular lista de filiais rapidamente sem renderizar
    data.forEach(item => {
      if (item.FILIAL_ID && !installmentsSearchModalData.current.branchList[item.FILIAL_ID]) {
        installmentsSearchModalData.current.branchList[item.FILIAL_ID] = item.FILIAL;
      }
    });

    const { branchList } = installmentsSearchModalData.current;

    // Slice para renderização progressiva (Lazy Load)
    const visibleData = data.slice(0, installmentsSearchModalData.current.renderLimit);

    const tableRows = visibleData.length > 0
      ? visibleData.map(renderTableRow).join('')
      : '<tr><td colspan="11" class="text-center">Nenhuma parcela encontrada</td></tr>';

    const html = `
      <div class="position-relative" style="height: 100vh; display: flex; flex-direction: column;">
        ${renderHeaderInfo(currentValue)}
        ${renderSearchArea(searchValue, selectedDate, selectedBranch, branchList)}
        <div class="table-responsive flex-grow-1" style="overflow-y: auto; max-height: calc(100% - 200px);">
          <table class="table table-striped table-bordered">
            <thead class="sticky-top" style="z-index: 1018; background-color: white;">
              <tr>
                <th style="min-width: 40px;"><input type="checkbox" id="select-all-installments" /></th>
                <th style="min-width: 60px;">Nr</th>
                <th style="min-width: 60px;">Filial</th>
                <th style="min-width: 120px;">Data Venc.</th>
                <th style="min-width: 120px;">Data Pag.</th>
                <th style="min-width: 120px;">Valor</th>
                <th style="min-width: 200px;">Cliente</th>
                <th style="min-width: 150px;">Categoria</th>
                <th style="min-width: 150px;">Centro de Custo</th>
                <th style="min-width: 150px;">Observação</th>
                <th style="min-width: 150px;">Ações</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </div>
      </div>
    `;

    if (is_on_load) {
      if (selectedDate != null) {
        $('#search-installments-by-date').trigger('change');
      }
      if (selectedBranch != null) {
        $('#search-installments-branches').trigger('change');
      }
    }

    modalBody.html(html);

    // Implementar Infinite Scroll
    const scrollContainer = modalBody.find('.table-responsive');
    scrollContainer.off('scroll').on('scroll', function () {
      const scrollTop = $(this).scrollTop();
      const innerHeight = $(this).innerHeight();
      const scrollHeight = $(this)[0].scrollHeight;

      // Carregar mais quando estiver perto do fim (200px de margem)
      if (scrollTop + innerHeight >= scrollHeight - 200) {
        const currentLimit = installmentsSearchModalData.current.renderLimit;
        if (currentLimit < data.length) {
          const newLimit = currentLimit + 50;
          const nextChunk = data.slice(currentLimit, newLimit);

          if (nextChunk.length > 0) {
            const newRowsHtml = nextChunk.map(renderTableRow).join('');
            $(this).find('tbody').append(newRowsHtml);
            installmentsSearchModalData.current.renderLimit = newLimit;
          }
        }
      }
    });

    // Adicionar estilos CSS apenas uma vez
    if (!document.getElementById('bank-reconciliation-styles')) {
      const style = document.createElement('style');
      style.id = 'bank-reconciliation-styles';
      style.textContent = `
        .table-responsive {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        
        .table {
          margin-bottom: 0;
          white-space: nowrap;
        }
        
        .table td, .table th {
          vertical-align: middle;
        }
        
        @media (max-width: 768px) {
          .table-responsive {
            max-height: calc(100vh - 350px);
          }
          
          .btn-group-sm > .btn {
            padding: 0.25rem 0.5rem;
          }
        }
      `;
      document.head.appendChild(style);
    }
  };

  const handleConciliate = (idx = null, installments = [], formData = null, isPartialPayment = false) => {
    //console.log('handleConciliate', formData);]
    if (installments.length > 0) {
      installmentsSearchModalData.current.formData.PARCELAS = installments;
    }
    Swal.fire({
      title: 'Conciliar lançamento',
      text: isPartialPayment ? `Term certeza que deseja conciliar esse lançamento como pagamento parcial?` : 'Tem certeza que deseja conciliar este lançamento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {
        const conciliationData = {
          ...(formData ? formData : installmentsSearchModalData.current.formData),
          ...(installments.length > 0 ? { PARCELAS: installments } : {}),
          ...(isPartialPayment ? { IS_PARTIAL_PAYMENT: true } : {})
        };
        //console.log('conciliating', conciliationData);
        //return;
        apiCall({
          method: 'PUT',
          endpoint: 'api/v1/financial/bank_reconciliation/conciliate',
          data: conciliationData,
          successCallback: function (response) {
            //console.log('success', response);
            if (!response.error) {
              window.toast({
                error: false,
                text: 'Lançamento conciliado'
              });
              installmentsSearchModalData.current.idx = null;
              installmentsSearchModalData.current.currentValue = 0;
              installmentsSearchModalData.current.fetchedData = [];
              installmentsSearchModalData.current.filteredData = false;
              installmentsSearchModalData.current.debounceSearchInstallments = null;
              installmentsSearchModalData.current.formData = null;
              removeBodyData(idx !== null ? idx : installmentsSearchModalData.current.idx);
              $('#modal-bank-reconciliation-search-financial-installments').modal('hide');
            }
          },
          errorCallback: function (response) {
            console.log('error', response);
          }
        });
      } else {
        //console.log('cancelled');
      }
    });
  }

  const fetchInstallmentSearchModalData = (selectedDate = null, searchValue = null) => {
    const modalBody = $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body');
    modalBody.html('<div class="d-flex justify-content-center align-items-center"><div class="spinner-border" role="status"><span class="visually-hidden">Carregando...</span></div></div>');
    installmentsSearchModalData.current.branchList = {};
    apiCall({
      method: 'GET',
      endpoint: 'api/v1/installments?notConciliated=true&branch=' + formData.FILIAL_ID + '&selectedDate=' + selectedDate + '&searchValue=' + searchValue,
      successCallback: function (response) {
        if (!response.error) {
          installmentsSearchModalData.current.fetchedData = response.data;
          renderInstallmentsSearchModalData(true);
          $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').unblock();
        } else {
          $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').html('<div class="alert alert-danger">Erro ao carregar lançamentos</div>');
          $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').unblock();
        }
      },
      errorCallback: function (response) {
        console.log('error', response);
        Swal.fire({
          title: 'Erro',
          text: 'Erro ao carregar lançamentos',
          icon: 'error'
        });
        $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').html('<div class="alert alert-danger">Erro ao carregar lançamentos</div>');
        $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').unblock();
      }
    });
  }

  const cleanupInstallmentsSearchModal = () => {
    $(document).off('change', '#select-all-installments');
    $(document).off('change', '.installment-checkbox');
    $(document).off('click', '#bank-reconciliation-confirm-installments');
    $(document).off('change', '#search-installments-by-date');
    $(document).off('change', '#search-installments-branches');
    $(document).off('keyup', '#search-installments');
    $(document).off('click', '.js-conciliation-duplicate-installment');
    $(document).off('click', '.js-conciliation-delete-installment');

    // Resetar os estados
    installmentsSearchModalData.current = {
      idx: null,
      currentValue: 0,
      searchValue: null,
      selectedDate: null,
      selectedBranch: null,
      branchList: {},
      fetchedData: [],
      filteredData: false,
      debounceSearchInstallments: null,
      formData: null
    };

    // Limpar cache de renderização
    modalRenderCache.current = {
      lastData: null,
      lastSearchValue: null,
      lastSelectedDate: null,
      lastSelectedBranch: null,
      lastCurrentValue: null
    };

    hasInitializedInstallmentsSearchModal.current = false;
  };

  React.useEffect(() => {
    startInstallmentsSearchModal();
    return () => {
      cleanupInstallmentsSearchModal();
    };
  }, []);

  return (
    <div className="col-sm-12">
      <div className="mb-3 card">
        <button className="btn btn-primary mb-3" data-bs-toggle="modal" data-bs-target="#modal-financial-insert-bills-to-pay">Cadastrar despesa</button>
        <div className="col-12 p-2">
          <ul className="nav nav-tabs" id="BankReconciliationTabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="all-tab" data-bs-toggle="tab" data-bs-target="#all" type="button" role="tab" aria-controls="all" aria-selected="true" onClick={() => setCurrentTab('all')}><h6>Todos</h6><br /><span className="badge bg-secondary">{bodyData.filter(item => true).length}</span></button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="receivables-tab" data-bs-toggle="tab" data-bs-target="#receivables" type="button" role="tab" aria-controls="receivables" aria-selected="false" onClick={() => setCurrentTab('receivables')}><h6>Recebimentos</h6><br /><span className="badge bg-success">{bodyData.filter(item => item.TIPO == 0).length}</span></button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="payables-tab" data-bs-toggle="tab" data-bs-target="#payables" type="button" role="tab" aria-controls="payables" aria-selected="false" onClick={() => setCurrentTab('payables')}><h6>Pagamentos</h6><br /><span className="badge bg-danger">{bodyData.filter(item => item.TIPO == 1).length}</span></button>
            </li>
          </ul>
          <div className="tab-content" id="BankReconciliationTabsContent">
            <div className="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
              {currentTab === 'all' && renderTabContent()}
            </div>
            <div className="tab-pane fade" id="receivables" role="tabpanel" aria-labelledby="receivables-tab">
              {currentTab === 'receivables' && renderTabContent()}
            </div>
            <div className="tab-pane fade" id="payables" role="tabpanel" aria-labelledby="payables-tab">
              {currentTab === 'payables' && renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BankReconciliationBody;